module.exports = {"title":"NOT FOUND","sub_title":"404 ERROR","description":"404 ERROR"}


//////////////////
// WEBPACK FOOTER
// ./src/config/error404.json
// module id = 574
// module chunks = 0